// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { IBlogCollectionModel } from "@vanmeter/XDL/types";

export interface IBlogListResponse {
    statusCode: number;
    result: IBlogCollectionModel;
}

export interface IBlogListParams extends ApiParameter {
    blogType?: string;
    category?: string;
    sortBy?: string;
    pageSize?: number;
    page?: number;
    pageTarget?: string;
    brand?: string;
}

export interface IBlogDetailsModel {
    title: string;
    summary: string;
    image: string;
    imageAltText: string;
    type: string;
    categories: string[];
    brands: string[];
    showCategoriesOption: boolean;
    publishDate: string;
}

const baseServiceUri = "/api/vmi/bloglist";

export const getBlogsList = async (params: IBlogListParams): Promise<IBlogListResponse> => {
    const result: IBlogListResponse = await get<IBlogListResponse>(baseServiceUri + "/getBlogs", params);
    return result;
};

export const getTopLevelCategories = async (): Promise<string[]> => {
    const result: string[] = await get<string[]>(baseServiceUri + "/blogCategories");
    return result;
};

export const getBlogTypes = async (type: string = ""): Promise<string[]> => {
    const result: string[] = await get<string[]>(baseServiceUri + "/blogTypes/" + type);
    return result;
};

export const getBlog = async ({ pageId }: { pageId: string }): Promise<IBlogDetailsModel> => {
    const result: IBlogDetailsModel = await get<IBlogDetailsModel>(baseServiceUri + "/blog/" + pageId);
    return result;
};
